import { ProjectSDKCodeStatus } from "@pl-flight-recorder/common/models/enum/project-sdk-code-status";
import axios from "axios";

export interface SDKCodeResponse {
  id: string;
  sdkCodeId: string;
  platform: string;
  codingLanguage: string;
  parameterHash: string;
  parameters: {
    UseScenes?: string;
    UIEntryPoint?: string;
    entryPoint?: string;
  };
  instructions: {
    title: string;
    sections: SDKInstructionSection[];
  };
  createdUserId: string;
  status: ProjectSDKCodeStatus;
  createdAt: Date;
  updatedAt: Date;
  appKeys: {
    appKey: string;
    createdAt: Date;
    updatedAt: Date;
  }[];
}

export interface SDKInstructionSection {
  content?: Array<SDKContentSection>;
  list?: Array<{
    content: Array<SDKContentSection>;
    codeBlock?: {
      code: string;
      filename: string;
    };
  }>;
}

export interface SDKContentSection {
  text?: string;
  code?: string;
  link?: {
    text: string;
    url: string;
  };
}

class MfaSDKCodeService {
  private static instance: MfaSDKCodeService;
  private baseUrl = `${process.env.REACT_APP_API_BASE_URL}/flight-recorder`;

  private constructor() {}

  public static getInstance(): MfaSDKCodeService {
    if (!MfaSDKCodeService.instance) {
      MfaSDKCodeService.instance = new MfaSDKCodeService();
    }
    return MfaSDKCodeService.instance;
  }

  public async getInstallInstructions(
    token: string,
    params: {
      platform: string;
      codingLanguage: string;
    },
  ): Promise<SDKCodeResponse[]> {
    console.log(token);
    try {
      const response = await axios.get<SDKCodeResponse[]>(
        `${this.baseUrl}/sdk-code/list`,
        {
          params,
          // headers: {
          //   Authorization: `Bearer ${token}`
          // }
        },
      );
      console.log("getInstallInstructions", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch SDK instructions:", error);
      throw error;
    }
  }

  public async getSDKCodeByParameters(
    token: string,
    params: {
      platform: string;
      codingLanguage: string;
      parameters: string;
      projectId: string;
    },
  ): Promise<SDKCodeResponse> {
    try {
      const response = await axios.get<SDKCodeResponse>(
        `${this.baseUrl}/sdk-code/by-parameters`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      console.log("getSDKCodeByParameters", response.data);
      // return this.exampleResponse;
      return response.data;
    } catch (error) {
      console.error("Failed to fetch SDK code by parameters:", error);
      throw error;
    }
  }

  public async getSDKListByApp(
    token: string,
    projectId: string,
    status?: string,
  ): Promise<SDKCodeResponse[]> {
    try {
      const params: Record<string, string> = {};
      if (status) {
        params.status = status;
      }

      const response = await axios.get<SDKCodeResponse[]>(
        `${this.baseUrl}/sdk-code/list/project/${projectId}`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      console.log("getSDKListByApp", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch SDK project list:", error);
      throw error;
    }
  }

  // Example instructions for testing
  // exampleInstructions = {
  //   title: "Swift + UIKit with Scenes",
  //   sections: [
  //     {
  //       content: [
  //         {
  //           text: "If your application is written in Swift and uses UIKit as the entry point to the UI, and uses Scenes, having a SceneDelegate file, follow these steps:",
  //         },
  //       ],
  //     },
  //     {
  //       list: [
  //         {
  //           content: [
  //             {
  //               text: "Open the SceneDelegate file and add the",
  //             },
  //             {
  //               code: "import PulseLabsFlightRecorderSDK",
  //             },
  //             {
  //               text: "statement to the top of the file:",
  //             },
  //           ],
  //           codeBlock: {
  //             code: "import UIKit\n\n// Insert the import statement:\nimport PulseLabsFlightRecorderSDK\n\nclass SceneDelegate: UIResponder, UIWindowSceneDelegate {",
  //             filename: "SceneDelegate.m",
  //           },
  //         },
  //         {
  //           content: [
  //             {
  //               text: "Add the",
  //             },
  //             {
  //               code: 'FlightRecorderSDK.start(apiKey: "YOUR_API_KEY")',
  //             },
  //             {
  //               text: "line of code in the",
  //             },
  //             {
  //               code: "sceneDidBecomeActive(_:)",
  //             },
  //             {
  //               text: 'delegate method, replacing "YOUR_API_KEY" with your own API key. There are also 2 other parameters that are optional:\n- surveyName: if you have designed an in-app survey on the portal, then supply the unique survey name string here, and it will show that instead of the default form\n- customFontsLib: you can also create an instance of FlightRecorderCustomFontsLib and pass it here. The SDK then will use that font to decorate the in-app survey form with it.',
  //             },
  //           ],
  //           codeBlock: {
  //             code: 'func sceneDidBecomeActive(_ scene: UIScene) {\n    // Insert the FlightRecorderSDK.start statement:\n    FlightRecorderSDK.start(apiKey: "YOUR_API_KEY",\n                            surveyName: "SURVEY_NAME"?,\n                            customFontsLib: FlightRecorderCustomFontsLib?)\n}',
  //             filename: "SceneDelegate.m",
  //           },
  //         },
  //       ],
  //     },
  //     {
  //       content: [
  //         {
  //           text: "The SDK is now installed! Run your app on a real device (the SDK will not work in a simulator) and the introduction screen will appear on the first run. You can then shake or take a screenshot to capture the video content and send a report.\nIf you have any issues, head to the",
  //         },
  //         {
  //           link: {
  //             text: "Troubleshooting section",
  //             url: "https://pulselabs.gitbook.io/pulse-flightrecorder-docs/sdk-documentation/pulse-labs-flightrecorder-documentation/ios/troubleshooting",
  //           },
  //         },
  //         {
  //           text: ".",
  //         },
  //       ],
  //     },
  //   ],
  // };

  // exampleResponse: SDKCodeResponse = {
  //   id: "1",
  //   platform: "iOS",
  //   codingLanguage: "Swift",
  //   parameterHash: "1234567890",
  //   parameters: {
  //     UseScenes: "true",
  //     UIEntryPoint: "SceneDelegate",
  //     entryPoint: "sceneDidBecomeActive",
  //   },
  //   instructions: this.exampleInstructions,
  //   createdUserId: "1",
  //   status: SDKCodeStatus.VALID,
  //   createdAt: new Date(),
  //   updatedAt: new Date(),
  // };
}

export default MfaSDKCodeService;
